(function() {
	// MODULE
	var Franchiser = (function() {
		var __private = {
			franchieses: document.getElementById("selectedDealerType"),
			noneClass: "display_none",

			listener(select) {
				if(select instanceof HTMLSelectElement) {
					__private.verify.apply(select);

					select.addEventListener("change", function() {
						__private.verify.apply(this);
					});
				}
			},

			verify() {
				var val    = this.value;
				var option = this.querySelector('option[data-alias="' + this.dataset['franchiseAlias'] + '"]');
				var type;

				if(option) type = option.value;

				if(val === type) __private.view(true);
				else __private.view(false);
			},

			view(isShow) {
				var select;

				if(this.franchieses instanceof HTMLElement) {
					select = this.franchieses.querySelector("select");

					if(select instanceof HTMLSelectElement) {
						switch (isShow) {
							case true:
								this.franchieses.classList.remove(this.noneClass);
								select.required = true;
								break;

							case false:
								this.franchieses.classList.add(this.noneClass);
								select.required = false;
								select.value = "";
								break;
						
							default:
								break;
						}
					}
				}
			}
		};

		return {
			init(select) {
				__private.listener(select);
			},

			show() {
				__private.view(true);
			},

			hidden() {
				__private.view(false);
			},

			verify(select) {
				if(select instanceof HTMLSelectElement) __private.verify.apply(select);
			}
		};
	})();

	// Run script
	document.addEventListener("DOMContentLoaded", function() {
		// var registerPage = document.getElementById("register");
		var registerForm = document.getElementById("c-registration-form");

		var dealerTypesSelect = document.getElementById("dealer_type");
		var sellerTypeSelect  = document.querySelector("#sellerTypeField select");
		
		if(dealerTypesSelect instanceof HTMLSelectElement) Franchiser.init(dealerTypesSelect);
		if(sellerTypeSelect  instanceof HTMLSelectElement) Franchiser.init(sellerTypeSelect);


		// REGISTER PAGE
		if(registerForm instanceof HTMLElement) {
			// first init
			setTimeout(() => {
				var seller = document.getElementById("seller");
				var dealer = document.getElementById("dealer");

				if(seller instanceof HTMLInputElement && seller.checked) {
					setFields(seller);
					Franchiser.verify(document.getElementById("seller_type"));

				} else if(dealer instanceof HTMLInputElement && dealer.checked) {
					setFields(dealer);
					Franchiser.verify(document.getElementById("dealer_type"));
				}
			}, 100);

			// event
			document.addEventListener("click", function(event) {
				event = event || window.event;
				var target = event.target;

				setFields(target);
			});
		}

		// functions
		function setFields(target) {
			var seller = document.getElementById("seller");
			var dealer = document.getElementById("dealer");

			var sellerField = document.getElementById("sellerTypeField");
			var dealerField = document.getElementById("dealerTypeField");

			if(target instanceof HTMLInputElement && target.type === "radio") {
				switch (target) {
					case seller:
						userSwitch(sellerField, dealerField);
						break;

					case dealer:
						userSwitch(dealerField, sellerField);
						break;
				
					default:
						break;
				}
			}
		}

		function userSwitch(active, inactive) {
			var noneClass  = "display_none";

			if(active   instanceof HTMLElement) {
				active.classList.remove(noneClass);
				active.querySelector("select").required = true;
			}

			if(inactive instanceof HTMLElement) {
				inactive.classList.add(noneClass);
				inactive.querySelector("select").required = false;
			}

			Franchiser.hidden();

			setTimeout(() => {
				Franchiser.verify(active.querySelector("select"));
			}, 100);
		}
	});
})();